import React from "react";
import { Container, Paper, Stack, Typography } from "@mui/material";

const NotFound = () => (
  <Container maxWidth="md" sx={{ py: 6 }}>
    <Paper elevation={6} sx={{ p: 4, background: "rgba(18,26,39,0.9)" }}>
      <Stack spacing={1}>
        <Typography variant="h4" fontWeight={700} color="#f9c74f">
          404
        </Typography>
        <Typography variant="body1" color="#c7d4e5">
          The page you are looking for does not exist.
        </Typography>
      </Stack>
    </Paper>
  </Container>
);

export default NotFound;
